<template>
    <div class="project_modular ">
        <div id="departmental_declaration_echarts">
        </div>
    </div>
</template>
<script>
import * as echarts from "echarts";
import "echarts-liquidfill";
import "@/util/echarts-auto-tooltip";

export default {
    name: 'departmentalDeclaration',
    data() {
        return {
            chart: null,
            tooltipTimerGet: null,
        }
    },
    props: {
        dataInfo: {
            type: Object,
            default: () => {
                return [
                    {
                        insApiCountRatio: [],
                        insApiSuccessRatio: []
                    }
                ]
            }
        }
    },
    beforeDestroy() {
        if (!this.chart) {
            return;
        }
        this.tooltipTimer.clearLoop();
        this.chart.dispose();
        this.chart = null;
    },
    mounted() {

    },
    methods: {
        initChart() {
            let that = this
            this.chart = echarts.init(
                document.getElementById("departmental_declaration_echarts")
            );
            window.addEventListener("resize", function () {
                if (that.chart) {
                    that.chart.resize();

                }
            });
            this.$nextTick(() => {
                this.getDetail();
            });
        },
        async getDetail() {


            let deptTypeList = this.dataInfo.deptTypeList

            let xAxisData = []
            let seriesData = []

            
            if(deptTypeList.length>0){
                deptTypeList[0].list.map(item=>{
                    seriesData.push({
                        name: item.projectTypeName,
                        type: 'bar',
                        emphasis: {
                            focus: 'series'
                        },
                        stack: "Search Engine",
                        data:[]
                    })
                })
                
            }
            deptTypeList.map(item => {
                xAxisData.push(item.createDeptName);

                let nameList=seriesData.map(item=>{
                    return item.name
                })
                item.list.map(el => {
                    if(!(nameList.includes(el.projectTypeName))){
                        seriesData.push({
                            name: el.projectTypeName,
                            type: 'bar',
                            emphasis: {
                                focus: 'series'
                            },
                            stack: "Search Engine",
                            data:[]
                        })
                        
                    }
                    seriesData.map(el_=>{
                        if(el_.name==el.projectTypeName){
                            el_.data.push(el.projectTypeCount)
                        }
                    }) 

                })
                      
            })
            
            
            
            
            let legendData = seriesData.map(item => {
                return item.name
            })
            this.setOptions(legendData, xAxisData, seriesData);


        },
        setOptions(legendData, xAxisData, seriesData) {
            let option = {
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "shadow",
                    },

                },
                // color: ["rgba(10,186,255,1)", "rgba(7,232,174,1)"],
                color: ["#0abaff", "#07e8ae", "#F2637B", "#FBD337", "#59D4D4", "#4ECB73", '#5470c6', '#91cc75', '#fac858', '#ee6666', '#73c0de', '#3ba272', '#fc8452', '#9a60b4', '#ea7ccc'],
                legend: {
                    show: true,
                    data: legendData,
                    orient: "horizontal",
                    x: "center",
                    y: "4%",
                    icon: "circle",
                    itemWidth: 16,
                    itemHeight: 16,
                    // itemGap: 20,
                    align: "auto",
                    type: 'scroll',
                    textStyle: {
                        padding: [1, 0, 0, 0]
                    },
                },
                grid: {
                    left: "3%",
                    right: "4%",
                    bottom: "6%",
                    containLabel: true,
                },
                xAxis: {
                    type: "category",
                    data: xAxisData.map(item => {
                        return item.replace('至', ' 至\n')
                    }),
                    axisLabel: {
                        color: "#A6B1B4",
                    },
                },
                yAxis: {
                    name: "单位:个",
                    type: "value",
                    nameTextStyle: {
                        color: "#ffffff",
                        padding: [0, 0, 20, 0],
                    },
                    splitLine: {
                        lineStyle: {
                            color: "#EEEEEE",
                        },
                    },
                    axisLabel: {
                        color: "#A6B1B4",
                    },
                },
                series: seriesData
                // [
                //     {
                //         name: "总调用量",
                //         type: "bar",
                //         data: seriesData,
                //         stack: "Search Engine",

                //         // itemStyle: {
                //         //     color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                //         //         { offset: 1, color: "rgba(10,186,255,1)" },
                //         //         { offset: 0.8, color: "rgba(10,186,255,0.8)" },
                //         //         { offset: 0, color: "rgba(10,186,255,0.8)" },
                //         //     ]),
                //         // },
                //     },
                //     {
                //         name: "计费数量",
                //         type: "bar",
                //         data: seriesData,
                //         stack: "Search Engine",

                //         // itemStyle: {
                //         //     color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                //         //         { offset: 1, color: "rgba(7,232,174,1)" },
                //         //         { offset: 0.8, color: "rgba(7,232,174,0.8)" },
                //         //         { offset: 0, color: "rgba(7,232,174,0.8)" },
                //         //     ]),
                //         // },
                //     },
                // ],
            };

            this.tooltipTimer =
                // = autoHover(this.chart, option, 3, 3000);
                // eslint-disable-next-line no-undef
                tools.loopShowTooltip(this.chart, option, {
                    loopSeries: true,
                });
            this.chart.setOption(option);
        },
        updateChart() {
            this.tooltipTimer.clearLoop();
            this.getDetail();
        }

    }

}
</script>
<style lang="scss" scoped>
$base_width: 1920;
$base_height: 1080;

@function vw($px) {
    @return ($px / $base_width) * 100vw;
}

@function vh($px) {
    @return ($px / $base_height) * 100vh;
}

.project_modular {

    height: vh(445);

    #departmental_declaration_echarts {
        width: 100%;
        height: vh(445);
    }


}
</style>
